export interface SlotLocationAddress {
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
  phone?: string;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestSlotLocationAddress: SlotLocationAddress = {
  street1: '123 West Fourth Street',
  street2: 'Apt 1A',
  city: 'Marshfield',
  state: 'WI',
  zip: '54449',
  phone: '7151112222',
};
